export enum EEpubPostMessageType {
    sender = 'ebook-content',
    init = 'ebook-content-init',
    globalError = 'ebook-content-global-error',
    ready = 'ebook-content-ready',
    error = 'ebook-content-error',
    xray = 'ebook-content-xray',
}

export const mapPostMessageTypeToRadar: Record<EEpubPostMessageType, string | null> = {
    [EEpubPostMessageType.sender]: 'sender',
    [EEpubPostMessageType.init]: 'init',
    [EEpubPostMessageType.globalError]: 'globalError',
    [EEpubPostMessageType.ready]: 'ready',
    [EEpubPostMessageType.error]: 'error',
    [EEpubPostMessageType.xray]: null,
};
